import { FC } from 'react';
import { CommonModal } from '../CommonModal';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import { NewOrderUpdateMessageModalViewType } from '../../types/view/MessageModalViewType';
import { BottomButton } from '../ModalItem/BottomButton';

export const NewOrderUpdateMessageModal: FC<{
  active: boolean;
  closeFunc: () => void;
  newOrderUpdateMessageModal: NewOrderUpdateMessageModalViewType | null;
}> = ({ active, closeFunc, newOrderUpdateMessageModal }) => {
  if (!newOrderUpdateMessageModal) return null;

  const content = (
    <>
      <div
        className={commonModalClass.newOrderUpdateMessageContainer}
        style={{ marginBottom: newOrderUpdateMessageModal.clickDeliveryDateFunc ? '10px' : '40px' }}
      >
        <div className={commonModalClass.newOrderUpdateMessageTitle}>
          ご注文ありがとうございます。
        </div>
        <div className={commonModalClass.border} />
        <div style={{ marginTop: '24px' }}>
          <span className={commonModalClass.newOrderUpdateMessageSquare}>今回のお届け</span>
          2～3<span style={{ fontWeight: 400 }}>日以内に発送します</span>
        </div>
        <div style={{ marginTop: '32px' }}>
          <span className={commonModalClass.newOrderUpdateMessageSquare}>次回のお届け</span>
          {newOrderUpdateMessageModal.nextDeliveryDateStr}
          {newOrderUpdateMessageModal.clickDeliveryDateFunc && (
            <span className={commonModalClass.newOrderUpdateMessageErrorCircle}>!</span>
          )}
        </div>
        {newOrderUpdateMessageModal.clickDeliveryDateFunc && (
          <div className={commonModalClass.newOrderUpdateMessageError}>
            {newOrderUpdateMessageModal.intervalCount}
            {newOrderUpdateMessageModal.intervalCount === 4 ? '週間' : '日'}後に変更できませんでした
          </div>
        )}
      </div>
      <div
        className={commonModalClass.btnContainer}
        style={{ marginBottom: '12px' }}
      >
        {newOrderUpdateMessageModal.clickDeliveryDateFunc ? (
          <button
            className={commonModalClass.btnPrimary}
            onClick={newOrderUpdateMessageModal.clickDeliveryDateFunc}
          >
            次回お届け日を変更する
          </button>
        ) : (
          <BottomButton
            buttonTitle="閉じる"
            clickFunc={closeFunc}
          />
        )}
      </div>
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
    >
      {content}
    </CommonModal>
  );
};
